export function temModuloOportunidades(state = {}) {
  const tenant = state.inquilino || state.user?.inquilino || {};
  return (tenant.modulosContratacao || []).some(
    (m) => ["CLP", 44, "44"].includes(m.tipo) && m.ativo !== false
  );
}
export function podeOportunidades(state = {}, acao = "List") {
  return (
    temModuloOportunidades(state) &&
    (state.permissoes || []).includes(`ROLE_OportunidadePublica_${acao}`)
  );
}
export function localOportunidade(o = {}) {
  if (o.esfera === "MUNICIPAL")
    return (
      [o.municipio, o.uf].filter(Boolean).join(" / ") ||
      traduzirOportunidade(
        this,
        "Oportunidades_Cidade_nao_informada",
        "Cidade não informada"
      )
    );
  if (o.esfera === "ESTADUAL")
    return (
      o.uf ||
      traduzirOportunidade(
        this,
        "Oportunidades_Estado_nao_informado",
        "Estado não informado"
      )
    );
  if (o.esfera === "DISTRITAL")
    return (
      o.uf ||
      traduzirOportunidade(
        this,
        "Oportunidades_Distrito_Federal",
        "Distrito Federal"
      )
    );
  return (
    [o.municipio, o.uf].filter(Boolean).join(" / ") ||
    traduzirOportunidade(
      this,
      "Oportunidades_Abrangencia_nacional",
      "Abrangência nacional"
    )
  );
}
export function moedaOportunidade(value) {
  if (value == null || value === "")
    return traduzirOportunidade(
      this,
      "Oportunidades_Nao_informado",
      "Não informado"
    );
  return new Intl.NumberFormat(this?.$i18n?.locale || "pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(Number(value));
}
export function dataOportunidade(value) {
  if (!value)
    return traduzirOportunidade(
      this,
      "Oportunidades_Nao_informada",
      "Não informada"
    );
  // As datas da API já estão no horário de Brasília; não reconverter o fuso.
  const [date, time] = String(value).split("T");
  const [year, month, day] = date.split("-");
  const data = new Intl.DateTimeFormat(this?.$i18n?.locale || "pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(Number(year), Number(month) - 1, Number(day), 12));
  return `${data}${
    time
      ? ` ${traduzirOportunidade(this, "Oportunidades_as", "às")} ${time.slice(
          0,
          5
        )}`
      : ""
  }`;
}
// Data e hora atuais em Brasília, no mesmo formato das datas da API.
export function agoraOportunidade(data = new Date()) {
  return new Intl.DateTimeFormat("sv-SE", {
    timeZone: "America/Sao_Paulo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  })
    .format(data)
    .replace(" ", "T");
}
export function hojeOportunidade(agora = agoraOportunidade()) {
  return agora.slice(0, 10);
}
export function somarDiasOportunidade(iso, dias) {
  const data = new Date(`${iso.slice(0, 10)}T12:00:00Z`);
  data.setUTCDate(data.getUTCDate() + dias);
  return data.toISOString().slice(0, 10);
}
// Compara datas locais como se fossem UTC: as duas pontas já estão no horário de Brasília.
function instanteOportunidade(value) {
  return Date.parse(`${String(value).slice(0, 19)}Z`);
}
function diasEntreOportunidade(de, ate) {
  return Math.round(
    (Date.parse(`${ate.slice(0, 10)}T00:00:00Z`) -
      Date.parse(`${de.slice(0, 10)}T00:00:00Z`)) /
      86400000
  );
}
// Contagem regressiva do encerramento das propostas, como nos selos dos cards.
export function prazoOportunidade(value, agora = agoraOportunidade()) {
  if (!value) return null;
  const fim = instanteOportunidade(value);
  if (Number.isNaN(fim)) return null;
  if (fim <= instanteOportunidade(agora))
    return { nivel: "ENCERRADO", dias: 0 };
  const dias = diasEntreOportunidade(agora, value);
  return {
    nivel:
      dias === 0
        ? "HOJE"
        : dias <= 3
        ? "URGENTE"
        : dias <= 7
        ? "PROXIMO"
        : "NORMAL",
    dias,
    hora: String(value).slice(11, 16),
    data: String(value).slice(0, 10),
  };
}
// Mesmo texto no card, na lista e no detalhe.
export function textoPrazoOportunidade(prazo) {
  if (!prazo) return "";
  if (prazo.nivel === "ENCERRADO")
    return this.$t("Oportunidades_Prazo_encerrado");
  if (prazo.nivel === "HOJE")
    return this.$t("Oportunidades_Encerra_hoje", { hora: prazo.hora });
  // Prazos distantes (credenciamentos abertos por anos) leem melhor como data.
  if (prazo.dias > 30)
    return `${this.$t("Oportunidades_Propostas_ate")} ${dataOportunidade.call(
      this,
      prazo.data
    )}`;
  return this.$tc("Oportunidades_Encerra_em_dias", prazo.dias, {
    dias: prazo.dias,
  });
}
// Entrou no catálogo nas últimas 24 horas.
export function novaOportunidade(o = {}, agora = agoraOportunidade()) {
  return (
    !!o.criadoEm &&
    instanteOportunidade(agora) - instanteOportunidade(o.criadoEm) <= 86400000
  );
}
// A fonte publicou alteração nos últimos 7 dias, depois da inclusão no catálogo.
export function alteradaOportunidade(o = {}, agora = agoraOportunidade()) {
  if (!o.alteradaNaFonte) return false;
  const alteracao = instanteOportunidade(o.alteradaNaFonte);
  return (
    instanteOportunidade(agora) - alteracao <= 7 * 86400000 &&
    (!o.criadoEm || alteracao - instanteOportunidade(o.criadoEm) > 3600000)
  );
}
export const REGIOES_OPORTUNIDADES = {
  NORTE: ["AC", "AM", "AP", "PA", "RO", "RR", "TO"],
  NORDESTE: ["AL", "BA", "CE", "MA", "PB", "PE", "PI", "RN", "SE"],
  CENTRO_OESTE: ["DF", "GO", "MS", "MT"],
  SUDESTE: ["ES", "MG", "RJ", "SP"],
  SUL: ["PR", "RS", "SC"],
};
// Mesmas etapas que o backend trata como acompanhamento encerrado.
export const ETAPAS_FINALIZADAS = [
  "NAO_VENCIDA",
  "CONTRATADA",
  "DESISTENCIA",
  "ARQUIVADA",
];
export function urlOficial(value) {
  try {
    const u = new URL(value);
    return ["http:", "https:"].includes(u.protocol) &&
      !u.username &&
      !u.password
      ? u.href
      : null;
  } catch {
    return null;
  }
}
export function limparFiltro(f) {
  return Object.fromEntries(
    Object.entries(f).filter(
      ([, v]) =>
        v !== null &&
        v !== undefined &&
        v !== "" &&
        !(Array.isArray(v) && !v.length)
    )
  );
}
const SITUACOES_ENCERRADAS = [
  "REVOGADA",
  "ANULADA",
  "CANCELADA",
  "ENCERRADA",
  "DESERTA",
  "FRACASSADA",
];
// Suspensa não recebe propostas enquanto durar a suspensão, como no backend.
const SITUACOES_SEM_PARTICIPACAO = [...SITUACOES_ENCERRADAS, "SUSPENSA"];
// Encerradas, suspensas e com prazo vencido ficam fora da busca, salvo pedido explícito do usuário.
export function somenteVigentes(f = {}) {
  return (
    f.incluirEncerradas !== true &&
    !SITUACOES_SEM_PARTICIPACAO.includes(f.situacao) &&
    !(f.situacoes || []).some((s) => SITUACOES_SEM_PARTICIPACAO.includes(s)) &&
    f.fase !== "PROPOSTAS_ENCERRADAS"
  );
}
export function erroOportunidade(e, contexto) {
  const mensagem = e?.response?.data?.message;
  return (
    (mensagem && mensagemOportunidade.call(contexto, mensagem)) ||
    traduzirOportunidade(
      contexto,
      "Oportunidades_Nao_foi_possivel_concluir_Tente_novamente",
      "Não foi possível concluir. Tente novamente."
    )
  );
}

// O erro de uma resposta em blob também chega como arquivo: volta a JSON para ler a mensagem.
export async function baixarPdfOportunidade(requisicao, nomeArquivo) {
  try {
    const resposta = await requisicao;
    const url = URL.createObjectURL(
      new Blob([resposta.data], { type: "application/pdf" })
    );
    const link = document.createElement("a");
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    const dados = e?.response?.data;
    if (dados instanceof Blob) {
      try {
        e.response.data = JSON.parse(await dados.text());
      } catch {
        e.response.data = {};
      }
    }
    throw e;
  }
}

export function mensagemOportunidade(mensagem) {
  if (!mensagem) return "";
  const key = `Oportunidades_Erro_${mensagem
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Za-z0-9]+/g, "_")
    .replace(/^_|_$/g, "")}`;
  return this?.$te?.(key) ? this.$t(key) : mensagem;
}

function traduzirOportunidade(contexto, key, fallback) {
  return contexto?.$t ? contexto.$t(key) : fallback;
}

export function rotuloOportunidade(grupo, valor, original) {
  if (!valor) return this.$t("Oportunidades_Nao_informado");
  const key = `Oportunidades_Enum_${grupo}_${valor}`;
  return this.$te(key) ? this.$t(key) : original || valor;
}

export const oportunidadesI18n = {
  computed: {
    dominiosTraduzidos() {
      return Object.fromEntries(
        Object.entries(this.dominios || {}).map(([grupo, lista]) => [
          grupo,
          Array.isArray(lista) && grupo !== "fontes"
            ? lista.map((item) => ({
                ...item,
                text: rotuloOportunidade.call(
                  this,
                  grupo,
                  item.value,
                  item.text
                ),
              }))
            : lista,
        ])
      );
    },
  },
  methods: { rotulo: rotuloOportunidade, mensagemFonte: mensagemOportunidade },
};
export const UFS_OPORTUNIDADES = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];
